import React, { FC } from "react";
import { withProcedureWraper } from "..";

export const ProcedureAccountingPage: FC = withProcedureWraper(() => {
  return <div className="ProcedureAccountingPage"></div>;
});
